export default __webpack_public_path__ + "static/media/gov.cd381691.svg";